export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-c41e47470317dff4b6d294e25dd3499d.svg";